<template src='./index.html'></template>
<script>
import data from './data.js';
import { addgs_quey } from '@/api/ywlxgz';

export default {
    name: 'ywlxzt_addzt_addgs',
    components: {},
    props: {
        gsdiag: {
            type: Boolean,
            default: false
        },
        //用于判断是哪个界面
        wikiType: {
            type: String,
            default: ''
        },
        checkTableData: {
            type: Array,
            default: null
        }
    },
    watch: {
        gsdiag: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.fetchResultShow(this.checkTableData);
                });
            }
        },
        checkTableData: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {

                });
            }
        }
    },
    data: function() {
        return {
            value: '1',
            pagination: data.pagination,
            tablekey: 0,
            overlength: 0,
            headData: data.headData,
            tableData: [],
            searchlist: data.searchlist,
            searchdata: data.searchdata,
            searchdiag: false,
            selectData: [],
            editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike', 'link', 'image', 'code-block'], // toggled buttons
                        [
                            {
                                align: []
                            }
                        ], //对齐方式
                        [
                            {
                                header: [1, 2, 3, 4, 5, 6, false]
                            }
                        ], //几级标题
                        [
                            {
                                font: []
                            }
                        ], //字体
                        [
                            {
                                size: ['small', 'normal', 'large', 'huge']
                            }
                        ],
                        [
                            {
                                color: []
                            },
                            {
                                background: []
                            }
                        ] // 字体颜色，字体背景颜色
                    ]
                }
            }
        };
    },
    created() {

    },
    methods: {
        fetchResultShow(data) {
            // 数据查询
            let params = JSON.parse(JSON.stringify(this.searchdata));
            addgs_quey(params).then(res => {
                if (res.data.code !== 1) {
                    this.$message.error(res.data.msg);
                } else {
                    this.pagination.total = res.data.data.total;
                    this.tableData = res.data.data.records;
                    let companyMap = data.map(d => d.companyCode);

                    this.$nextTick(() => {
                        if (companyMap.length !== 0) {
                            let list = this.tableData.filter(d => companyMap.includes(d.companyCode));
                            this.$refs.companyTable.toggleSelection(list);
                        }
                    });
                }
            })
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.fetchResultShow(this.checkTableData);
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.fetchResultShow(this.checkTableData);
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.fetchResultShow(this.checkTableData);
        },
        closediag() {
            this.$emit('closediag', false);
        },
        addgs() {
            this.selectData = this.$refs.companyTable.getSelectionval();
            this.$emit('closediag', false);
        },
        geOoverLength(e) {
            this.overlength = e;
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
